import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';
import {Title} from '@angular/platform-browser';
import {FormBuilder, Validators} from "@angular/forms";
import {TripService} from '../../trip.service';

@Component({
  selector: 'app-trip-edit-travel',
  templateUrl: './trip-edit-travel.component.html',
  styleUrls: ['./trip-edit-travel.component.css', '../../../app.component.css', '../../admin.css'],
  providers: [TripService]
})
export class TripEditTravelComponent implements OnInit {

  errorMessage : any;
  Info: any;
  travelInfo:any;
  type:any;
  spinner: boolean = false;
  eventUserId:any;

  constructor(private pageTitle: Title,private router: Router, public dialogRef: MdDialogRef<TripEditTravelComponent>, private formBuilder: FormBuilder, private tripService: TripService,private snackBar: MdSnackBar) { }

  ngOnInit() {
    this.travelInfo={
      arriveByPlane : (this.Info.arriveByPlane==1)?this.Info.arriveByPlane:0,
    };
    this.Info.arriveDateTime=(this.Info.arriveByPlane==1)?this.Info.arriveDateTime:'';
    this.Info.returnDateTime=(this.Info.arriveByPlane==1)?this.Info.returnDateTime:'';
    this.travelInfo={
      userId:this.Info.userId,
      eventId : this.Info.eventId,
      eventUserId:this.Info.id,
      arriveByPlane : (this.Info.arriveByPlane)?this.Info.arriveByPlane:0,
      arriveFlightName : (this.Info.arriveFlightName)?this.Info.arriveFlightName:'',
      arriveFlightNumber : (this.Info.arriveFlightNumber)?this.Info.arriveFlightNumber:'',
      arriveDateTime : this.Info.arriveDateTime,
      arrivalTime : this.setTravelTime(this.Info.arrivalTime,this.Info.arrivalTimeOld),
      returnTime : this.setTravelTime(this.Info.returnTime,this.Info.returnTimeOld),
      arriveDateTime_ : (this.Info.arriveDateTime)?this.getRoundDatesNew(this.Info.arriveDateTime):'',
      arriveNames : (this.Info.arriveNames)?this.Info.arriveNames:'',
      returnFlightName : (this.Info.returnFlightName)?this.Info.returnFlightName:'',
      returnFlightNumber : (this.Info.returnFlightNumber)?this.Info.returnFlightNumber:'',
      returnDateTime : this.Info.returnDateTime,
      returnDateTime_ : (this.Info.returnDateTime)?this.getRoundDatesNew(this.Info.returnDateTime):'',
      returnNames : (this.Info.returnNames)?this.Info.returnNames:'',
      checkIn : (this.Info.checkIn)?this.Info.checkIn:'',
      checkIns : (this.Info.checkIn)?this.Info.checkIn:'',
      checkOut : (this.Info.checkOut)?this.Info.checkOut:'',
      checkOuts : (this.Info.checkOut)?this.Info.checkOut:'',
    };
  }

  setTravelTime(current,Old){
    //console.log(current)
    if(current!='null' && current!='' && Old!='12:00 AM'){
      return Old;
    }else{
      return current;
    }
  }

  getRoundDatesNew(dt){
    var dts;
    if(dt){
      dts = dt.split(' ');
      return dts[0]
    }else
      return '';

  }

  editAtt(info){
    if(info.valid){
      //console.log(this.travelInfo.arriveDateTime);
      //console.log(this.travelInfo.returnDateTime);
      this.travelInfo.arriveDateTime = this.toSqlTime(this.travelInfo.arriveDateTime_);
      this.travelInfo.returnDateTime = this.toSqlTime(this.travelInfo.returnDateTime_);
      this.travelInfo.checkIn = this.toSqlTime(this.travelInfo.checkIns);
      this.travelInfo.checkOut = this.toSqlTime(this.travelInfo.checkOuts);
      console.log(this.toSqlTime(this.travelInfo.arriveDateTime_));
      console.log(this.toSqlTime(this.travelInfo.returnDateTime_))
      this.spinner = true;
      this.tripService.updateTripTravelInfo({  travelInfo:this.travelInfo, type:this.type }).subscribe(
              response => {
            this.spinner = false;
            if(response.status)
            {
              this.snackBar.open('Travel info updated successfully','',{duration:4000});
              this.dialogRef.close(response.status);
            }
            else{
              this.snackBar.open(response.msg,'',{duration:4000});
              this.spinner = false;
            }
          },
              error => {
            this.spinner = false;
          }
      );

    }
  }

  dateTimeFormat(dt){
    if(dt)
    {
      var m = dt.getMonth()+1;
      if(m<10)
        m='0'+m;
      var d = dt.getDate();
      if(d<10)
        d='0'+d;
      return dt.getFullYear()+'-'+m+'-'+d+' 00:00:00';
    }
    else
      return '';
  }


  toSqlTime(dt){
    var s = '';

    if(dt)
    {
      if(typeof(dt)=='object')
      {
        s += dt._d.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
        s += ' ';
        s += dt._d.toTimeString().split(' ')[0];
      }
      else
        return dt;
    }
    return s;
  }

  toUsSqlTime(dt){
    var s = '';
    if(dt && typeof(dt)=='object')
    {
      s += dt._d.toLocaleDateString();
      s += ' ';
      s += dt._d.toLocaleTimeString();
    }
    return s;
  }

  close() {
    this.dialogRef.close();
  }

  triggerClick(id){
    (<HTMLInputElement>window.document.getElementById(id)).click()
  }

  validateDate(dt){
    if(dt) {
      dt = new Date(dt);
      return (dt != 'Invalid Date');
      //var comp = dt.toString().split('/');
      //
      //if (comp.length !== 3) {
      //  return false;
      //}
      //dt = new Date(dt);
      //return (dt != 'Invalid Date');
    }
    return true;
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/trip/trip-edit-travel/trip-edit-travel.component.ts